export const TOGGLE_ALL_CONSUMERS = 'events/TOGGLE_ALL_CONSUMERS';

/**
 * @return {{type: string}}
 */
export const toggleAllConsumers = (payload) => ({ type: TOGGLE_ALL_CONSUMERS, payload });
